import { useLazyQuery } from '@apollo/client';
import { RESOURCES } from '../graphql/queries/content';
export const useLazyFetchResources = ({ clientId, includePublicUrl = false, }) => {
    const [fetch] = useLazyQuery(RESOURCES, {
        variables: { spec: { clientId, includePublicUrl } },
    });
    const fetchResources = async (id) => {
        const { data } = await fetch({
            variables: { spec: { clientId, id, includePublicUrl } },
        });
        return data?.resources || [];
    };
    return {
        fetchResources,
    };
};
